import { Outlet, useParams } from "react-router";
import DeleteBikeDialog from "../../components/DeleteBikeDialog";
import Header from "../../components/Header";
import Icon from "../../components/Icon";
import { useBike } from "../../hooks/useBikes";
import useToggle from "../../hooks/useToggle";
import Page from "../../layouts/Page";
import Delete from "./../../components/icons/delete.svg?react";

const BikePage = () => {
  const params = useParams<"bikeId">();
  const bikeId = String(params.bikeId);
  const { data: bike } = useBike(bikeId);
  const deleteDialog = useToggle();

  return (
    <>
      <Header
        backLink="/garage"
        heading={bike?.name}
        tabs={[
          { text: "Fork", to: "fork" },
          { text: "Shock", to: "shock" },
        ]}
      >
        <button onClick={() => deleteDialog.open()}>
          <Icon glyph={Delete} />
        </button>
      </Header>
      <Page>
        <Outlet />
      </Page>
      <DeleteBikeDialog
        bikeId={bikeId}
        open={deleteDialog.isOpen}
        onClose={deleteDialog.close}
      />
    </>
  );
};

export default BikePage;
